<template>
  <div class="c-resource-list">
    <!-- TODO: -->
    <pre>THIS IS A RESOURCE LIST</pre>
  </div>
</template>

<script>
export default {
  name: 'resource-list',

  props: ['resource'],
};
</script>

<style>
.c-resource-list {
}
</style>
